<template>
  <div>
    <vx-card>
      <div class="flex items-center gap-3 font-medium">
        <p style="width: 114px">대상기간</p>
        <search-nav-item-select v-model="year" :list="getYearList" style="width: 70px !important" />
        <p class="mx-2 text-center">년</p>
        <search-nav-item-select v-model="month" :list="getMonthList" style="width: 70px !important" />
        <p class="ml-2 text-center">월</p>
      </div>
    </vx-card>
    <div class="flex items-center justify-end my-4">
      <vs-button type="border" color="secondary" @click="excelDownWithHtml('safety_staff_management_daily')">Excel 다운로드</vs-button>
    </div>

    <table id="safety_staff_management_daily">
      <colgroup>
        <col width="200" />
        <col v-for="_ in 16" :key="_" />
        <col width="100" />
        <col width="100" />
      </colgroup>
      <tbody>
        <tr>
          <th rowspan="2">직종</th>
          <th colspan="2">일반건강진단</th>
          <th colspan="7">배치전 건강진단</th>
          <th colspan="7">특수건강진단</th>
          <th rowspan="2">소계(월)</th>
          <th rowspan="2">누계(년)</th>
        </tr>
        <tr>
          <th>C2</th>
          <th>D2</th>
          <th>C1</th>
          <th>C2</th>
          <th>CN</th>
          <th>D1</th>
          <th>D2</th>
          <th>DN</th>
          <th>R</th>
          <th>C1</th>
          <th>C2</th>
          <th>CN</th>
          <th>D1</th>
          <th>D2</th>
          <th>DN</th>
          <th>R</th>
        </tr>

        <fragment v-if="summaryData">
          <tr v-for="cf in classifications" :key="cf">
            <th>{{ cf }}</th>
            <td>{{ summaryData[cf]["일반"].C2 }}</td>
            <td>{{ summaryData[cf]["일반"].D2 }}</td>
            <td>{{ summaryData[cf]["배치전"].C1 }}</td>
            <td>{{ summaryData[cf]["배치전"].C2 }}</td>
            <td>{{ summaryData[cf]["배치전"].CN }}</td>
            <td>{{ summaryData[cf]["배치전"].D1 }}</td>
            <td>{{ summaryData[cf]["배치전"].D2 }}</td>
            <td>{{ summaryData[cf]["배치전"].DN }}</td>
            <td>{{ summaryData[cf]["배치전"].R }}</td>
            <td>{{ summaryData[cf]["특수"].C1 }}</td>
            <td>{{ summaryData[cf]["특수"].C2 }}</td>
            <td>{{ summaryData[cf]["특수"].CN }}</td>
            <td>{{ summaryData[cf]["특수"].D1 }}</td>
            <td>{{ summaryData[cf]["특수"].D2 }}</td>
            <td>{{ summaryData[cf]["특수"].DN }}</td>
            <td>{{ summaryData[cf]["특수"].R }}</td>
            <td>{{ summaryData[cf]["소계"].월 }}</td>
            <td>{{ summaryData[cf]["소계"].년 }}</td>
          </tr>
        </fragment>
      </tbody>
    </table>

    <!-- <PopupExcelDownload v-model="showExcelDownload" :list="getExcelList" :title="getExcelFileName" :show-header="false" /> -->
  </div>
</template>

<script>
import SearchNavItemSelect from "@/components/nav/SearchNavItemSelect.vue";
import PopupExcelDownload from "@/popup/PopupExcelDownload.vue";
import XLSX from "xlsx";

export default {
  components: {
    SearchNavItemSelect,
    PopupExcelDownload,
  },
  computed: {
    projectId() {
      return parseInt(this.$route.params.proj_id) || 0;
    },
    getYearList() {
      const currentYear = new Date().getFullYear();
      const startYear = currentYear + 1 - 49;
      const endYear = currentYear + 1;
      const yearList = [];
      for (let i = startYear; i <= endYear; i++) {
        yearList.push({ text: `${i}`, value: i });
      }
      return yearList.reverse();
    },
    getMonthList() {
      const monthList = [];
      for (let i = 0; i < 12; i++) {
        const month = i + 1;
        monthList.push({ text: `${month}월`, value: month });
      }
      return monthList;
    },
    getExcelFileName() {
      let title = "유소견자 건강 상담 실적 통계";
      title += `_${this.year}년`;
      title += `_${this.month}월`;
      return title;
    },
  },
  data() {
    return {
      showExcelDownload: false,

      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1,
      cachedData: {},
      summaryData: null,

      classifications: ["공무원", "공무직", "임기제", "기간제", "기능직", "근로자", "공공근로", "노인일자리", "장애인일자리", "지역공동체", "합계"],
    };
  },
  created() {
    this.loadListBoard();
  },
  watch: {
    year: {
      handler() {
        this.loadListBoard();
      },
    },
    month: {
      handler() {
        this.loadListBoard();
      },
    },
  },
  methods: {
    setSummaryData() {
      this.summaryData = this.classifications.reduce((prev, curr) => {
        return { ...prev, [curr]: { 일반: { C2: 0, D2: 0 }, 배치전: { C1: 0, C2: 0, CN: 0, D1: 0, D2: 0, DN: 0, R: 0 }, 특수: { C1: 0, C2: 0, CN: 0, D1: 0, D2: 0, DN: 0, R: 0 }, 소계: { 월: 0, 년: 0 } } };
      }, {});
    },
    async loadListBoard() {
      this.setSummaryData();

      // 게시글 불러온다
      const targetYear = this.year;
      const targetMonth = this.month;

      if (this.cachedData[`${targetYear}-${targetMonth}`]) {
        this.summaryData = this.cachedData[`${targetYear}-${targetMonth}`];
      } else {
        // 없으면 API를 호출한다
        const data = await this.$store.dispatch("board/LOAD_361_SUMMARY", {
          projectId: this.projectId,
          targetYear,
          targetMonth,
        });

        this.parseData(data);
      }
    },
    parseData(data) {
      if (0 < Object.keys(data).length) {
        const targetYear = this.year;
        const targetMonth = this.month;

        const currDateData = data[`${this.year}-${this.month}`];
        const _summaryData = JSON.parse(JSON.stringify(this.summaryData));

        for (const key in currDateData) {
          const keys = key.split(".");
          if (2 < keys.length && _summaryData[keys[0]] && _summaryData[keys[0]][keys[1]]) {
            _summaryData[keys[0]][keys[1]][keys[2]] = currDateData[key];
          } else if (keys[1] === "누계") {
            // 배치후 합계를 가져온다
            const currDateDataKeys = Object.keys(currDateData);
            const currDateDataKeysFilter = currDateDataKeys.filter((ck) => {
              return ck.includes(`${keys[0]}.배치후`);
            });
            const 배치후합계 = currDateDataKeysFilter.reduce((prev, curr) => {
              return prev + currDateData[curr];
            }, 0);

            // 소계를 계산한다
            _summaryData[keys[0]]["소계"]["월"] = currDateData[key] - 배치후합계;
          }
        }

        // 년도별 누계를 가져온다
        const yearFilterDatas = [];
        for (const key in data) {
          const keys = key.split("-");
          if (1 < keys.length && keys[1] <= targetMonth) yearFilterDatas.push(data[key]);
        }

        const yearFilterData = yearFilterDatas.reduce((prev, curr) => {
          if (!prev) return curr;
          else return this.sumObjectKey(prev, curr);
        }, null);
        if (yearFilterData) {
          let yearKeys = Object.keys(yearFilterData);

          yearKeys.map((yk) => {
            const keys = yk.split(".");
            if (this.classifications.includes(keys[0]) && keys[1] === "누계") {
              // 배치후 합계를 가져온다
              const cyearKeysFilter = yearKeys.filter((ck) => {
                return ck.includes(`${keys[0]}.배치후`);
              });
              const 배치후합계 = cyearKeysFilter.reduce((prev, curr) => {
                return prev + currDateData[curr];
              }, 0);

              _summaryData[keys[0]]["소계"]["년"] = yearFilterData[yk] - 배치후합계;
            }
          });
        }

        this.summaryData = _summaryData;

        this.cachedData[`${targetYear}-${targetMonth}`] = _summaryData;
      }
    },
    sumObjectKey(data1, data2) {
      const result = {};
      for (const key in data1) {
        result[key] = data1[key] + data2[key];
      }
      return result;
    },
    excelDownWithHtml(tableName) {
      let wb = XLSX.utils.table_to_book(document.getElementById(tableName), { sheet: this.getExcelFileName, raw: true });
      XLSX.writeFile(wb, `${this.getExcelFileName}.xlsx`);
    },
  },
};
</script>

<style lang="scss" scoped>
table {
  table-layout: fixed;
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #ddd;
  tr:last-child {
    td {
      background: #f9f9f9;
    }
  }
  th,
  td {
    border: 1px solid #cdcdcd;
    font-size: 14px;
    font-weight: 400;
    text-align: center;
    padding: 14px 4px;
  }

  th {
    background-color: #f9f9f9;
  }
}
</style>
